export function determineHelpResource(href, pageHelpResourceMap) {

  const url = new URL(href);

  for (let key in pageHelpResourceMap) {

    if (url.pathname.startsWith(key) === false) {
      continue;
    }

    return pageHelpResourceMap[key];

  }

}